// extracted by mini-css-extract-plugin
module.exports = {"header":"layout-header_standard_header__MyGDD"};